import { render, staticRenderFns } from "./AdditionalFunction.html?vue&type=template&id=369bedad&external"
import script from "./AdditionalFunction.ts?vue&type=script&lang=ts&external"
export * from "./AdditionalFunction.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports